import { useCustomerJourney } from '../../../context/setup';
import RichTextEditor from '@/components/RichTextEditor/RichTextEditor';
import { InfoIcon } from 'lucide-react';
import { PaymentMethod } from '../../../context/types';
import { useAuth } from '@/contexts';
import { DEFAULT_INSTRUCTIONS } from '../../../context/utils';

interface PaymentInstructionsProps {
  paymentMethod: PaymentMethod;
  onInstructionsChange: (html: string) => void;
}

export const PaymentInstructions: React.FC<PaymentInstructionsProps> = ({
  paymentMethod,
  onInstructionsChange
}) => {
  const { state } = useCustomerJourney();
  const { session } = useAuth();

  const country = session?.vendor?.country || 'AR';

  const isTransfer = paymentMethod === PaymentMethod.TRANSFER;
  const defaultInstructions =
    DEFAULT_INSTRUCTIONS[paymentMethod as keyof typeof DEFAULT_INSTRUCTIONS]?.[
      country as keyof typeof DEFAULT_INSTRUCTIONS[PaymentMethod.TRANSFER]
    ];
  const currentInstructions = isTransfer ? state.transferInstructions : state.cashInstructions;

  const handleInstructionsChange = (html: string) => {
    onInstructionsChange(html);
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="text-center mb-4">
        <h1 className="text-2xl font-medium text-gray-900">
          Instrucciones para {isTransfer ? 'transferencias' : 'pagos en efectivo'}
        </h1>
        <p className="text-gray-600">
          Configura las instrucciones que verán tus clientes al momento de pagar
        </p>
      </div>

      <div className="mb-6">
        <div className="mb-4">
          <div className="payment-instructions-editor">
            <RichTextEditor
              id="instructions-rich-text-input"
              content={currentInstructions || defaultInstructions}
              placeholder="Agrega instrucciones"
              onChange={handleInstructionsChange}
              limit={1000}
              heigth="min-h-[150px]"
            />
          </div>
        </div>

        <div className="bg-gray-200 p-4 rounded-lg flex items-start text-sm mb-6">
          <InfoIcon className="mr-2 flex-shrink-0" />
          <p className="text-gray-700">
            Estas instrucciones se mostrarán al cliente cuando elija pagar mediante
            {isTransfer ? ' transferencia bancaria' : ' efectivo'}. Incluye toda la información necesaria para
            el proceso de pago.
          </p>
        </div>
      </div>
    </div>
  );
};
